import { PayloadAction } from '@reduxjs/toolkit';
import { ProductState } from 'store/product/types';

interface toggleProductAttributePayload {
  typeName: string;
  value: string;
  multiple: boolean;
}
const toggleProductAttributeReducer = (state: ProductState, action: PayloadAction<toggleProductAttributePayload>) => {
  const { value, multiple, typeName } = action.payload;
  const targetAttribute = state.productAttributes[typeName];
  if (!targetAttribute || !multiple) {
    state.productAttributes[typeName] = [value];
    return;
  }
  const isSelected = targetAttribute.find((selectedValues) => selectedValues === value);
  if (isSelected) {
    state.productAttributes[typeName] = state.productAttributes[typeName].filter((attribute) => attribute !== value);
  } else {
    state.productAttributes[typeName].push(value);
  }
};

export default toggleProductAttributeReducer;
